import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export { ActionsRow } from '../styles';

export const FieldGroup = styled.div`
  margin-bottom: 1.25rem;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;

  > * {
    flex: 1;
    min-width: 200px;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
`;

export const SectionLabel = styled.p`
  font-size: 0.9rem;
  font-weight: 500;
  color: #282828;
  margin: 0 0 0.5rem;
`;

export const SignaturesButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
`;

export const SignatureChips = styled.div`
  border-radius: 0.25rem;
  border: 1px solid rgba(0, 0, 0, 0.3);
  padding: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-height: 2.5rem;
  align-items: center;
`;

export const SignatureChip = styled.span`
  background-color: #e7e7e7;
  color: #000;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.85rem;
`;

export const SignatureEmptyMessage = styled.span`
  font-size: 0.85rem;
  color: #757575;
`;

export const SelectedCourseHint = styled.small`
  display: block;
  margin-top: 0.35rem;
  color: #616161;
`;

export const PlaceholderContainer = styled.div`
  padding: 3rem 1rem;
  text-align: center;
  color: #757575;
`;

export const PasteRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const ModuleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const ModuleCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
  padding: 0.75rem;
`;

export const ModuleHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  > *:first-child {
    flex: 1;
  }
`;

export const AddModuleRow = styled.div`
  margin-bottom: 1rem;
`;

export const WarningText = styled.p`
  color: #b26a00;
  background-color: #fff3e0;
  border: 1px solid #ffcc80;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
  margin: 0 0 1rem;
`;

export const EmentaColumns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

export const EditorColumn = styled.div`
  flex: 1 1 320px;
  min-width: 280px;
`;

export const PreviewColumn = styled.div`
  flex: 0 0 auto;
`;

export const PreviewHeading = styled.h4`
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
  color: #282828;
`;

export const PreviewViewport = styled.div`
  width: 594px;
  height: 420px;
  overflow: hidden;
  max-width: 100%;
`;

export const PreviewPage = styled.div`
  width: 990px;
  height: 700px;
  transform: scale(0.6);
  transform-origin: top left;
  columns: 3;
  column-fill: auto;
  background: #fff;
  padding: 1rem;
  border: 1px solid #ccc;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
`;

export const ErrorText = styled.p`
  color: #c62828;
  background-color: #ffebee;
  border: 1px solid #ef9a9a;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
  margin: 0 0 0.5rem;
`;

export const StaleNotice = styled.p`
  color: #616161;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
  margin: 0 0 1rem;
`;

export const ParseRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

export const UploadLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #616161;
`;

export const EmptyState = styled.div`
  padding: 2rem 1rem;
  text-align: center;
  color: #888;
`;

export const StyledTableContainer = styled(Paper)`
  overflow-x: auto;
  margin-bottom: 1rem;
`;
